var path = 'app/scripts/modules/google/src/serverGroup/configure/wizard/capacity/zones.html';
var html = "<ng-form name=\"zonesSubForm\">\n  <div class=\"container-fluid form-horizontal\">\n    <gce-regional-selector command=\"command\"></gce-regional-selector>\n    <gce-zone-selector command=\"command\"></gce-zone-selector>\n  </div>\n</ng-form>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/google/src/serverGroup/configure/wizard/capacity/zones.html
// module id = 1349
// module chunks = 0